module.exports = __webpack_public_path__ + "static/media/energy.97977b7a.svg";